import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  IconButton,
  alpha
} from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import WordChips from './WordChips';

const LookupResults = ({ lookupResult, inputText, onCopy }) => {
  const theme = useTheme();

  if (!lookupResult) return null;

  return (
    <Box sx={{ mt: 4 }} className="card-fade-in">
      <Divider sx={{ mb: 3, borderColor: alpha(theme.palette.common.white, 0.1) }} />
      
      <Typography variant="h6" gutterBottom>
        Text Analysis Results
      </Typography>

      <Card 
        variant="outlined" 
        sx={{ 
          mb: 3, 
          bgcolor: theme.palette.background.paper,
          borderColor: alpha(theme.palette.common.white, 0.1)
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle2" color="primary">
              Original Text
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => onCopy(inputText)}
              sx={{ color: theme.palette.text.secondary }}
            >
              <CopyIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography variant="body1" paragraph>
            {inputText}
          </Typography>

          <Divider sx={{ my: 2, borderColor: alpha(theme.palette.common.white, 0.1) }} />
          
          <Typography variant="subtitle2" color="primary" gutterBottom>
            Word Lookup Results
          </Typography>

          <Box sx={{ mt: 2 }}>
            <WordChips
              title="Words Found"
              words={lookupResult.wordsFound}
              type="found"
            />

            <WordChips
              title="Words Not Found"
              words={lookupResult.wordsNotFound}
              type="notFound"
              emptyMessage="None"
            />

            <WordChips
              title="Non-Words Found"
              words={lookupResult.nonWordsFound}
              type="nonWord"
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LookupResults;